import {Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {DealDateTable} from "../../deal-dates/deal-dates.component";

export interface TaxCreditsTable {
  field: string;
  value: string;
}

@Component({
    selector: 'deal-tax-credits-table',
    templateUrl: './tax-credits-table.component.html',
    styleUrls: ['./tax-credits-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaxCreditsTableComponent implements OnInit{
  @ViewChild('dataSort') public dataSort: MatSort;
  @Input() importedTable: any;

  dataColumns: string[] = ['field', 'value'];
  dataSource: MatTableDataSource<DealDateTable>;

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.importedTable);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.dataSort;
  }
}
